<cmps-dialog class="h-100 cmps-cdk-pr-0dot75 cmps-cdk-ml-0dot25">
    <!-- intentionally not using background-image -->
    <div class="cmps-event-centre-dialog--icaw">
        <img
            src="assets/intelligent-coach-assist-watermark.svg"
            alt=""
            aria-hidden="true"
        />
    </div>
    <cmps-dialog-header>
        <div class="cmps-event-centre-dialog--header">
            <div>
                <img
                    class="cmps-event-centre-dialog--icai"
                    src="assets/intelligent-coach-assist-icon.svg"
                    alt=""
                    aria-hidden="true"
                />
            </div>
            <cmps-event-centre-tab-bar
                class="flex-grow-1"
                [class.cmps-cdk-d-none]="_service.state?.searchOpen"
            ></cmps-event-centre-tab-bar>
            <div
                class="cmps-cdk-d-flex cmps-cdk-align-items-center"
                [class.cmps-cdk-d-none]="_service.state?.searchOpen"
            >
                <div
                    class="cmps-cdk-mr-0dot5"
                    *ngFor="let a of _service.state?.category?.actions"
                >
                    <button
                        class="cmps-icon-button--no-bg"
                        [class.cmps-cdk-d-none]="a.styleHidden === true"
                        cmpsIconButton
                        [disabled]="a.styleDisabled === true"
                        [cmpsTooltipTrigger]="a.name"
                        (click)="_onCategoryActionClick(a)"
                        *ngIf="
                            a.displayAs?.toLowerCase() ===
                                _CategoryDisplayAs.Icon?.toLowerCase() ||
                            a.displayAs == null
                        "
                    >
                        <cmps-icon [svgIcon]="a.icon"></cmps-icon>
                    </button>
                    <button
                        class="cmps-cdk-min-w-auto cmps-cdk-min-h-34p cmps-cdk-border-color-blue-100 cmps-cdk-color-blue-100 not:disabled:hover:cmps-cdk-bg-color-blue-100 not:disabled:focus:cmps-cdk-bg-color-blue-100 not:disabled:hover:cmps-cdk-color-white not:disabled:focus:cmps-cdk-color-white not:disabled:hover:cmps-cdk-pseudo-child not:disabled:focus:cmps-cdk-pseudo-child"
                        [class.cmps-cdk-d-none]="a.styleHidden === true"
                        cmpsOutlineButton
                        [disabled]="a.styleDisabled === true"
                        (click)="_onCategoryActionClick(a)"
                        *ngIf="
                            a.displayAs?.toLowerCase() ===
                            _CategoryDisplayAs?.IconAndName?.toLowerCase()
                        "
                    >
                        <cmps-icon
                            class="cmps-cdk-fill-blue-100 not:disabled:hover:cmps-cdk-fill-white not:disabled:focus:cmps-cdk-fill-white"
                            [svgIcon]="a.icon"
                        ></cmps-icon>
                        <span cmpsOutlineButtonLabel>{{ a.name }}</span>
                    </button>
                </div>
            </div>
            <cmps-event-centre-search-filter></cmps-event-centre-search-filter>
            <div>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [cmpsTooltipTrigger]="_i18n._763_CLOSE | translate"
                    (click)="_service.close()"
                >
                    <cmps-icon svgIcon="close"></cmps-icon>
                </button>
            </div>
        </div>
    </cmps-dialog-header>
    <cmps-dialog-body class="cmps-event-centre-dialog--body cmps-cdk-pr-0dot5">
        <cmps-event-centre-card
            class="cmps-cdk-cursor-pointer cmps-cdk-mb-0dot5"
            [class.cmps-cdk-mt-0dot75]="first"
            [expanded]="i.expanded"
            (click)="_onToggleExpandClick(i); _onToggleReadClick(i, true)"
            *ngFor="let i of _service.state?.filteredItems; let first = first"
            #card
        >
            <cmps-event-centre-card-stripe
                [class.cmps-cdk-bg-color-grey-400]="i.read"
                [style.background-color]="i.colour"
            >
                <cmps-icon [svgIcon]="i.icon"></cmps-icon>
            </cmps-event-centre-card-stripe>
            <cmps-event-centre-card-name>
                <cmps-icon
                    svgIcon="account-circle"
                    [class.cmps-cdk-fill-grey-400]="i.read"
                    [style.color]="!i.read ? i.colour : ''"
                ></cmps-icon>
                <span cmpsEventCentreCardNameLabel>{{ i.title }}</span>
            </cmps-event-centre-card-name>
            <cmps-event-centre-card-message
                [class.cmps-cdk-bg-color-grey-200]="i.read"
            >
                <div cmpsEventCentreCardTarget>{{ i.name }}</div>
                <div
                    class="cmps-cdk-color-grey-400 cmps-cdk-py-0dot25"
                    [class.cmps-cdk-line-clamp-2]="!card.expanded"
                >
                    {{ i.message }}
                </div>
                <div cmpsEventCentreCardTimestamp>
                    {{ i.timestamp | cmpsDate: 'LLL dd y h:mm a' }}
                </div>
                <cmps-event-centre-card-actions
                    [class.cmps-cdk-overflow-hidden]="!card.expanded"
                >
                    <div cmpsEventCentreCardActionsLeft>
                        <ng-container *ngFor="let a of i.actions">
                            <button
                                class="cmps-cdk-bg-color-transparent"
                                cmpsCardIconButton
                                [cmpsTooltipTrigger]="a.name"
                                (click)="
                                    $event.preventDefault();
                                    $event.stopPropagation();
                                    _onActionClick(i, a)
                                "
                            >
                                <cmps-icon
                                    class="cmps-cdk-color-blue-100"
                                    [svgIcon]="a.icon ?? 'help-circle-outline'"
                                ></cmps-icon>
                            </button>
                        </ng-container>
                    </div>
                    <div cmpsEventCentreCardActionsRight>
                        <button
                            cmpsCardIconButton
                            [cmpsTooltipTrigger]="
                                (!i.read
                                    ? _i18n._11149_MARK_AS_READ
                                    : _i18n._11150_MARK_AS_UNREAD
                                ) | translate
                            "
                            (click)="
                                $event.preventDefault();
                                $event.stopPropagation();
                                _onToggleReadClick(i)
                            "
                        >
                            <cmps-icon
                                [class.cmps-cdk-color-blue-100]="i.read"
                                [svgIcon]="
                                    !i.read
                                        ? 'email-alert-outline'
                                        : 'email-check-outline'
                                "
                            ></cmps-icon>
                        </button>
                        <button
                            cmpsCardIconButton
                            [cmpsTooltipTrigger]="
                                _i18n._7424_DELETE | translate
                            "
                            (click)="
                                $event.preventDefault();
                                $event.stopPropagation();
                                _onDeleteClick(i)
                            "
                        >
                            <cmps-icon svgIcon="trash-can-outline"></cmps-icon>
                        </button>
                    </div>
                </cmps-event-centre-card-actions>
            </cmps-event-centre-card-message>
        </cmps-event-centre-card>
    </cmps-dialog-body>
</cmps-dialog>
